import '../App.css';
import Search from '../images/search.png';

export default function search({ searchTerm, setSearchTerm, search, handleKeyDown }) {

    return (
        <div className='search-container'>
            <div className='input-container'>
                <input
                    className='search-box'
                    type="text"
                    placeholder='Search Books'
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    onKeyDown={e => handleKeyDown(e)}
                />
                <button className='search-btn' onClick={() => search(searchTerm)}>
                    <img src={Search} alt='Search'/>
                </button>
            </div>
            
            <ul className='search-suggestions'>
                <li onClick={() => search('subject:fiction')}>Fiction</li>
                <li onClick={() => search('subject:medical')}>Medical</li>
                <li onClick={() => search('subject:art')}>Art</li>
                <li onClick={() => search('subject:nature')}>Nature</li>
                <li onClick={() => search('subject:cooking')}>Cooking</li>
                <li onClick={() => search('subject:psychology')}>Psychology</li>
            </ul>
        </div>
    )

}
